import {i18n} from '@online-offer/i18n';
import {Show, Space, Text, ValueByDevice, VStack} from 'platform/foundation';
import {useLocale} from 'platform/locale';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CommentExpandable} from '../../components/CommentExpandable/CommentExpandable';
import {FeatureCategoryRow} from '../../components/FeatureCategoryRow/FeatureCategoryRow';
import {Section} from '../../components/Section/Section';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getFeatures} from '../../utils/getFeatures';

/** Three columns once there is room for them; a phone gets a single flat list. */
const FEATURE_COLUMNS: ValueByDevice<number> = [1, 2, 3, 3];

export function Features() {
  const {vehicle, alphaCatalogue} = useGetOnlineOfferData();
  const locale = useLocale();
  const features = getFeatures({
    vehicle,
    alphaCatalogue,
    language: locale.language,
  });

  const shouldShowFeatures = features.length > 0;
  const shouldShowAdditionalInformation = isNotNilOrEmpty(vehicle?.featuresByManufacturer);

  return (
    <Show when={shouldShowFeatures || shouldShowAdditionalInformation}>
      <Section id="FEATURES" isWithBreakLine>
        <Show when={shouldShowFeatures}>
          <VStack spacing={9}>
            {features.map((category) => (
              <FeatureCategoryRow
                key={category.categoryKey}
                category={category}
                columns={FEATURE_COLUMNS}
              />
            ))}
          </VStack>
        </Show>
        <Show when={shouldShowFeatures && shouldShowAdditionalInformation}>
          <Space vertical={7} />
        </Show>
        <Show when={shouldShowAdditionalInformation}>
          <Text size="large" alternative>
            {i18n.t('features.additionalInformation')}
          </Text>
          <Space vertical={2} />
          <CommentExpandable hideCommentFlag comment={vehicle?.featuresByManufacturer} />
        </Show>
      </Section>
    </Show>
  );
}
